import { Action } from '@ngrx/store';
import { IUser } from 'src/app/store/interfaces/user.interface';

export enum EGlobalAppActions {
    GetAppWaiting = '[App] Get App Waiting',
    GetLoggedUser = '[App] Get User',
    SetAppWaiting = '[App] Set App Waiting',
    SetUser='[App] Set User'
}

export class GetAppWaiting implements Action {
    public readonly type = EGlobalAppActions.GetAppWaiting;
}
export class GetLoggedUser implements Action {
    public readonly type = EGlobalAppActions.GetLoggedUser;
}
export class SetAppWaiting implements Action {
    public readonly type = EGlobalAppActions.SetAppWaiting;
    constructor(public payload: boolean) { }
}
export class SetUser implements Action {
    public readonly type = EGlobalAppActions.SetUser;
    constructor(public payload: IUser) { }
}
export type AppActions = GetAppWaiting | GetLoggedUser | SetAppWaiting | SetUser;
